import Mutations from '../../odata/mutations';

export default { ...new Mutations('issue'), ...new Mutations('issues') };
